/**
 * The CRM trigger page (`/admin/crm-triggers`, ENG-2172).
 * Served by `apps/api/src/crm-admin`; every run returns the job's own result
 * as JSON, shown on the page as it is.
 */
/** The scheduled CRM jobs the page can fire by hand, keyed as the API takes them. */
export const crmTriggerJobLabels = {
    'clinic-health': 'Nightly clinic health',
    'onboarding-sync': 'Onboarding sync and alerts',
    'onboarding-digest': 'Monday onboarding digest',
    'calendar-sync': 'Calendar sync (next call, held calls)',
    'demo-reminders': 'Demo reminders',
    'contract-nudge': 'Unsigned-contract nudge',
    'csm-checkins': 'CSM two-day check-ins',
};
export const crmTriggerJobValues = Object.keys(crmTriggerJobLabels);
/** The onboarding sync's platform signals the page can switch on or off for a clinic. */
export const onboardingSignalLabels = {
    meta_connected: 'Meta connected',
    stripe_connected: 'Stripe payments set up',
    data_received: 'Data received',
};
export const onboardingSignalValues = Object.keys(onboardingSignalLabels);
/**
 * Who a hand-fired job's messages go to. `test` writes nothing to Twenty,
 * marks nothing as sent, and sends every message to one teammate labelled
 * with who it was meant for; `real` is the scheduled run.
 */
export const crmJobRunModeLabels = {
    test: 'Test: send everything to one person',
    real: 'Real: send to who they are meant for',
};
export const crmJobRunModeValues = Object.keys(crmJobRunModeLabels);
/**
 * The handoff flow test (`admin-terminal/crm-triggers/flow/*`): one made-up
 * clinic walked through the real CRM a step at a time, so each step can be
 * checked in Twenty before the next. Keyed as the API takes them, in order.
 */
export const crmFlowStepLabels = {
    booking: 'Demo booked on Cal.com',
    price: 'Closer sets the price and term',
    sign: 'Clinic signs the contract',
    pay: 'Clinic pays',
    account: 'Clinic makes its Borrah account',
    form: 'Clinic answers the setup questions',
    data: 'Onboarding: data received',
    connect: 'Onboarding: Stripe and Meta connected',
    setup: 'Onboarding: booking system set up, staff trained',
    live: 'First booking through Borrah: live',
    adopted: 'Two weeks of bookings: fully adopted',
    health: 'Nightly health score',
    checkin: 'Two-day CSM check-in',
    churn: 'Clinic churns',
};
export const crmFlowStepValues = Object.keys(crmFlowStepLabels);
/** What to look at in Twenty after each step. */
export const crmFlowStepChecks = {
    booking: 'A new contact and a deal at Call booked, owned by you, with the Cal.com note. The demo-booked DM comes to you.',
    price: 'The deal gets a monthly price and term. A minute later the Twenty webhook adds the payment link, the contract link and the setup link.',
    sign: 'The deal moves to Won with Contract: Signed and a "Contract signed" note.',
    pay: 'The deal gets Paid at; the clinic goes to Onboarding with a CSM, you as account owner, signed and target-live dates.',
    account: 'A clinic (company) appears, linked to the deal and the contact, with its Borrah org id.',
    form: 'The clinic gets Setup progress, its website platform and the onboarding form date. Skipping the booking-system invite DMs you (as the CSM).',
    data: 'The onboarding sync ticks Data received and counts progress.',
    connect: 'Payments set up and Meta connected are ticked.',
    setup: 'Booking system set up and Staff trained are ticked, as Eoin would; progress is full.',
    live: 'The clinic moves to Live with a live date.',
    adopted: 'The clinic moves to Fully adopted and its lifecycle to Active.',
    health: 'The clinic gets a health score, band and reasons. Any health alert DM comes to you.',
    checkin: 'With no touchpoint for three days, a check-in task assigned to you and the CSM check-in DM.',
    churn: 'Lifecycle Churned, and the health score run again.',
};
//# sourceMappingURL=crm-triggers.js.map